import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Constants } from '../constants/constants'
import { BaseList, BaseWithId } from '../models/base.model'

@Injectable()
export class BaseService {
    protected logPrefix: string
    protected constants: Constants
    protected $http: HttpClient

    constructor(http: HttpClient) {
        this.constants = Constants.getConstantsSingleton()
        this.$http = http
        this.logPrefix = `${this.constructor.name}: `
    }

    protected get baseUri(): string {
        return this.constants.API_URL + this.constants.VERSION_URL
    }

    protected async handleError(err: any): Promise<any> {
        this.logMessageByStatusCode(err)
        console.warn(`${this.logPrefix} ${err}`)

        return Promise.reject(err)
    }

    preCheckResponseData<T extends BaseWithId, S extends BaseList<any>>(
        response: HttpResponse<T | Array<T> | S>
    ): T | Array<T> | S {
        if (!response) {
            throw new Error('No response received')
        } else if (!response.body) {
            throw new Error('No response data received')
        }
        this.logMessageByStatusCode(response)

        return response.body
    }

    private logMessageByStatusCode<T extends BaseWithId, S extends BaseList<any>>(
        response: HttpResponse<T | Array<T> | S>
    ): void {
        let message = this.logPrefix
        if (response && response.status) {
            message += `${response.status} ${response.statusText}`

            if (response.url) {
                message += ` - URL: ${response.url}`
            }

            switch (response.status) {
                case 200:
                    console.info(message)
                    break
                case 201:
                    console.info(message)
                    break
                default:
                    console.warn(message)
                    break
            }
        }
    }
}
